<script lang="ts" setup>
import { WebhookIcon } from 'lucide-vue-next'
import DataStateLoading from '../../components/DataState/DataStateLoading.vue'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../components/ui/tooltip'
import { usePejerBase } from '../../stores/pejerData'
import usePejerMutation from '../../usePejerMutation'
import ProtectedButton from '../ProtectedButton.vue'
const props = defineProps<{
  connectedAccountID: string
}>()

const pejer = usePejerBase()
const { mutateAsync, isPending } = usePejerMutation(pejer.urls.connectedAccounts['rerun-webhook'], {
  queryKeys: [['webhooks']],
})
</script>
<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <ProtectedButton
          :disabled="isPending"
          variant="ghost"
          class="p-2 h-fit"
          @click.prevent.stop="
            mutateAsync({
              pathArgs: { id: props.connectedAccountID },
            })
          "
        >
          <DataStateLoading v-if="isPending" hide-text />
          <slot v-else> <WebhookIcon class="w-4 h-4" /> </slot>
        </ProtectedButton>
      </TooltipTrigger>
      <TooltipContent>
        <p>Rerun webhook</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
